<template>
    <div class="modal modal--rebrand over-all" id="modalWriteReview" tabindex="-1" role="dialog"
         aria-labelledby="modalWriteReviewTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <span class="title">{{ translate.account.reviews.writeReview }}</span>
                </div>

                <div class="modal-body">

                    <div class="form-group">
                        <div class="modal-review-stars-container">
                            <div v-for="entry in 5" @click="selectRating(entry)" class="modal-review-star" :class="{selected: rating >= entry}">
                                <icon-component :icon="fa_star()" />
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <input type="text" class="form-control-v2"
                               v-model.trim="title"
                               :class="{'error': !isValid && title.length < 3}"
                               :placeholder="translate.account.reviews.titlePlaceholder">
                        <error-component-with-icon v-if="!isValid && title.length < 3"
                                                   :message="translate.home.required">
                        </error-component-with-icon>
                    </div>

                    <div class="form-group">
                        <textarea class="form-control-v2" rows="4"
                                  v-model.trim="text"
                                  :class="{'error': !isValid && text.length < 3}"
                                  :placeholder="translate.account.reviews.textPlaceholder">
                        </textarea>
                        <error-component-with-icon v-if="!isValid && text.length < 3"
                                                   :message="translate.home.required">
                        </error-component-with-icon>

                        <p>
                            {{ translate.home.charactersLeft1 }} {{ textCharsLeft }}
                            {{ translate.home.charactersLeft2 }}
                        </p>
                    </div>

                    <p class="profile-reviews-info">
                        {{ translate.account.reviews.reviewInfo1 }}
                        <a :href="regionRelativeUrl('/erfahrungen-richtlinien')" target="_blank">
                            <u>{{ translate.account.reviews.reviewInfo2 }}</u>
                        </a>
                        {{ translate.account.reviews.reviewInfo3 }}
                    </p>

                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-rebrand-primary btn-rebrand-sm w-full disable-dark"
                            @click.stop="createReview"
                            :disabled="loading || rating === 0"
                            ref="submit">
                        {{translate.home.submit}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {fa_star} from "@/core/constants/icons";
import IconComponent from "@/components/global/IconComponent.vue";
import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";

const data = () => ({
    rating: 0,
    title: '',
    text: '',
    loading: false,
    isValid: true,
    textMaxLength: 500,
    eventResettingForm: 'hidden.bs.modal',
    selectorResettingForm: '#modalWriteReview',
    shouldResetForm: null,
});

function selectRating(rating) {
    this.rating = rating;
}

async function createReview() {
    if (!this.isFormValid()) {
        return;
    }

    this.loading = true;

    const payload = {
        profile_id: this.user.id,
        rating: this.rating,
        title: this.title,
        text: this.text,
    };

    const [err, response] = await to(
        api.user.reviews.create(payload)
    );

    this.loading = false;

    if (err || !_.get(response, 'data.success', false)) {
        const hasErrorMessage = _.get(err, 'response.data.message');

        if (hasErrorMessage) {
            return toastr.error(hasErrorMessage);
        }

        return toastr.error(_.get(this, 'translate.home.errorCommon'));
    }

    const review = _.get(response, 'data.review', false);
    if (review) {
        this.$emit('reviewCreated', _.cloneDeep(review));
    }

    $(this.selectorResettingForm).modal('hide');
}

function resetForm() {
    this.rating = 0;
    this.title = '';
    this.text = '';
    this.isValid = true;
    this.shouldResetForm = false;
}

function isFormValid() {
    this.isValid = this.formFilled;
    return this.isValid;
}

export default {
    components: {
        IconComponent,
    },
    mixins: [regionsUrlMixin],
    props: {
        user: Object,
    },
    data,
    mounted() {
        this.shouldResetForm = false;
        $(this.selectorResettingForm).on(this.eventResettingForm, () => {
            this.shouldResetForm = true;
        });
    },
    beforeDestroy() {
        window.clearModalFade();
    },
    computed: {
        formFilled() {
            return (
                this.title.length > 2
                && this.text.length > 2
            );
        },
        textCharsLeft() {
            return this.textMaxLength - _.get(this, 'text.length', 0);
        },
        ...mapState(['translate']),
    },
    watch: {
        textCharsLeft(value) {
            if (value <= -1) {
                this.text = this.text.substr(0, this.textMaxLength);
            }
        },
        shouldResetForm(value) {
            if (value) {
                this.resetForm();
            }
        }
    },
    methods: {
        fa_star,
        selectRating,
        createReview,
        resetForm,
        isFormValid,
    }
};
</script>
